<template>
  <div>
    <div class="header">
      <div></div>
      <button class="btn btn-secondary" @click="asCsv">CSV</button>
    </div>
    <PanelCard
      v-for="(c,i) of changesSorted" :key="`preview_row_${i}`"
      class="entity-diffs"
      :v-pad="12" :h-pad="4"
      collapsible collapsed collapseOnContentClick
    >
      <template #header>
        <div class="header">
          <div><b>{{$to(entityName(c.entity))}}</b> ({{(entityType(c.entity))}})</div>
          <div>{{c.diffs.length}} {{$t('inventory_staging.changes')}}</div>
        </div>
      </template>
      <template #default>
        <DiffSet ref="diffSet" :diffs="c.diffs" />
      </template>
    </PanelCard>
  </div>
</template>

<script>
import DiffSet from "@/components/inventory/DiffSet";
import PanelCard from "@/components/PanelCard";

export default {
  name: "StagingDiff",
  components: {DiffSet, PanelCard},
  props: {
    staging: Object
  },

  computed: {
    changesSorted() {
      return this.staging.changes.sort((c1, c2) => {
        let c1Entity = c1.entity;
        let c2Entity = c2.entity;
        let c1Type = this.entityType(c1Entity);
        let c2Type = this.entityType(c2Entity);
        if (c1Type !== c2Type) {
          return c1Type.localeCompare(c2Type);
        } else {
          let c1Name = this.$to(this.entityName(c1Entity));
          let c2Name = this.$to(this.entityName(c2Entity));
          return c1Name.localeCompare(c2Name);
        }
      })
    }
  },

  methods: {
    entityType(entity) {
      return entity ? entity.type : ''
    },
    entityName(entity) {
      return entity ? entity.name : {}
    },
    asCsv() {
      let data = [];
      for (let change of this.changesSorted) {
        let rowHeader = [
          this.entityType(change.entity),
          this.$to(this.entityName(change.entity))
        ];

        let diffSetHelperRef = this.$refs.diffSet[0]; /* hack-around */
        let formattedDiffs = diffSetHelperRef.formatDiffs(change.diffs);
        for (let d of formattedDiffs) {
          data.push([...rowHeader, d.k, d.o, d.n])
        }
      }

      let nameParts = [];
      nameParts.push('staging');
      if (typeof this.staging.name === 'string') {
        nameParts.push(this.staging.name.replace(/\s/g, '_'));
      } else if (this.staging.id && this.staging.id.toString) {
        nameParts.push(this.staging.id.toString());
      }
      if (typeof this.staging.context === 'string') {
        nameParts.push(this.staging.context);
      }
      let csvName = nameParts.join('_');
      window._downloadAsCsv(csvName, data);
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
}
.entity-diffs {
  margin-bottom: 4px;
  .header {
    display: flex;
    justify-content: space-between;
  }
}
</style>